import ApiService from './ApiService'

/**
 * Products Directory + Product Workspace — canonical catalogue products with
 * their commercial listings (inventory units) beneath them. Admin-only APIs.
 */

export async function apiGetCatalogueDirectory(params, signal) {
    return ApiService.fetchData({
        url: '/catalog/admin/catalogue-products/directory',
        method: 'get',
        params,
        ...(signal ? { signal } : {}),
    })
}

export async function apiGetCatalogueDirectorySummary() {
    return ApiService.fetchData({
        url: '/catalog/admin/catalogue-products/directory/summary',
        method: 'get',
    })
}

export async function apiGetCatalogueDirectoryBrands() {
    return ApiService.fetchData({
        url: '/catalog/admin/catalogue-products/directory/brands',
        method: 'get',
    })
}

export async function apiGetCatalogueWorkspace(id) {
    return ApiService.fetchData({
        url: `/catalog/admin/catalogue-products/${id}/workspace`,
        method: 'get',
    })
}

export async function apiUpdateCatalogueCard(id, data) {
    return ApiService.fetchData({
        url: `/catalog/admin/catalogue-products/${id}`,
        method: 'put',
        data,
    })
}

/** Soft-delete a product card + its listings (blocked when sold/reserved listings exist). */
export async function apiDeleteCatalogueCard(id) {
    return ApiService.fetchData({
        url: `/catalog/admin/catalogue-products/${id}`,
        method: 'delete',
    })
}

export async function apiPinCatalogueUnit(id, data) {
    return ApiService.fetchData({
        url: `/catalog/admin/catalogue-products/${id}/pin-unit`,
        method: 'post',
        data,
    })
}

/* ── Smart Product Creation ── */

export async function apiSearchModelTemplates(q, signal, filters = {}) {
    return ApiService.fetchData({
        url: '/catalog/admin/model-templates/search',
        method: 'get',
        params: { q, ...filters },
        ...(signal ? { signal } : {}),
    })
}

/** Which attribute fields a category asks (the recipe), without a model. */
export async function apiGetAttributeSlots(params = {}) {
    return ApiService.fetchData({
        url: '/catalog/admin/attribute-slots',
        method: 'get',
        params,
    })
}

export async function apiCheckCatalogueIdentity(data) {
    return ApiService.fetchData({
        url: '/catalog/admin/catalogue-products/check-identity',
        method: 'post',
        data,
    })
}

export async function apiCreateCatalogueProduct(data) {
    return ApiService.fetchData({
        url: '/catalog/admin/catalogue-products',
        method: 'post',
        data,
    })
}

/** Set a catalogue product's curated customer-facing gallery (approved assets). */
export async function apiSetCatalogueAssets(id, assets) {
    return ApiService.fetchData({
        url: `/catalog/admin/catalogue-products/${id}/assets`,
        method: 'put',
        data: { assets },
    })
}

/** Prefill for attaching a listing to an existing canonical product. */
export async function apiGetListingPrefill(id) {
    return ApiService.fetchData({
        url: `/catalog/sell/prefill/${id}`,
        method: 'get',
    })
}

/* ── Preorder campaigns + reservations ── */

export async function apiSetPreorderCampaign(id, data) {
    return ApiService.fetchData({
        url: `/catalog/admin/catalogue-products/${id}/preorder-campaign`,
        method: 'put',
        data,
    })
}

export async function apiGetPreorderReservations(params) {
    return ApiService.fetchData({ url: '/preorders/admin/list', method: 'get', params })
}

export async function apiGetPreorderSummary(params) {
    return ApiService.fetchData({ url: '/preorders/admin/summary', method: 'get', params })
}

export async function apiAdvanceReservation(id, data) {
    return ApiService.fetchData({ url: `/preorders/admin/${id}/status`, method: 'post', data })
}

export async function apiRequestBalance(id, data = {}) {
    return ApiService.fetchData({ url: `/preorders/admin/${id}/request-balance`, method: 'post', data })
}

export async function apiReceiveStock(data) {
    return ApiService.fetchData({ url: '/preorders/admin/receive-stock', method: 'post', data })
}

/** Bulk "Add Supply" — create sourceable listings for a set of catalogue products. */
export async function apiBulkSupply(payload) {
    return ApiService.fetchData({
        url: '/catalog/admin/catalogue-products/bulk-supply',
        method: 'post',
        data: payload,
    })
}
